import { Factory } from "./../core/factory";

import { BaseMark } from "./base/base-mark";

import { createImage, registerImage, registerShadowRoot } from "../vrender-bridge";

export class ImageMark extends BaseMark {
    constructor() {
        super(...arguments), this.type = ImageMark.type;
    }
    _getDefaultStyle() {
        return Object.assign(Object.assign({}, super._getDefaultStyle()), {
            width: void 0,
            height: void 0,
            lineWidth: 0
        });
    }
}

ImageMark.type = "image";

export const registerImageMark = () => {
    Factory.registerMark(ImageMark.type, ImageMark), registerShadowRoot(), registerImage(), 
    Factory.registerGraphicComponent("image", createImage);
};
//# sourceMappingURL=image.js.map
